import { Button, Icon } from '@pega/cosmos-react-core';
import type { MenuProps } from '@pega/cosmos-react-core';

export const getFilterRegex = (inputValue: string) => {
  return new RegExp(`^${inputValue.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')}`, 'i');
};

export const list: MenuProps['items'] = [
  { id: '1', primary: 'Joseph Morales', secondary: ['Experts', 'Engineer'] },
  { id: '2', primary: 'Nora Lee', secondary: ['Experts', 'Engineer'] },
  { id: '3', primary: 'Douglas Smith', secondary: ['Intermediate', 'Architect'] },
  { id: '4', primary: 'Vernon Lee', secondary: ['Intermediate', 'Product Owner'] },
  { id: '5', primary: 'Eula Morales', secondary: ['Intermediate', 'Architect'] },
  { id: '6', primary: 'Paul Smith', secondary: ['Leads', 'Engineer'] },
  { id: '7', primary: 'Frank Walker', secondary: ['Leads', 'Engineer'] },
  { id: '8', primary: 'Edward Green', secondary: ['Leads', 'Architect'] },
  { id: '9', primary: 'John Smith', secondary: ['Leads', 'Product Owner'] },
  { id: '10', primary: 'Olivia Cockburn', secondary: ['Experts', 'Engineer'] },
  { id: '11', primary: 'Reese Witherspoon', secondary: ['Experts', 'Engineer'] },
  { id: '12', primary: 'Peter Hernandez', secondary: ['Intermediate', 'Architect'] },
  { id: '13', primary: 'Helena Johnson', secondary: ['Intermediate', 'Product Owner'] },
  { id: '14', primary: 'Katheryn Hudson', secondary: ['Intermediate', 'Architect'] },
  { id: '15', primary: 'Mia Hershel', secondary: ['Leads', 'Engineer'] },
  { id: '16', primary: 'Ann Mitchell', secondary: ['Leads', 'Engineer'] },
  { id: '17', primary: 'Rafael Bottom', secondary: ['Leads', 'Architect'] },
  { id: '18', primary: 'Christopher Gatsby', secondary: ['Leads', 'Product Owner'] },
  { id: '19', primary: 'Julianne Moore', secondary: ['Experts', 'Engineer'] },
  { id: '20', primary: 'Emily Stone', secondary: ['Experts', 'Engineer'] },
  { id: '21', primary: 'Richard Wiles', secondary: ['Intermediate', 'Architect'] },
  { id: '22', primary: 'Ella Connor', secondary: ['Intermediate', 'Product Owner'] },
  { id: '23', primary: 'Robyn Fenton', secondary: ['Intermediate', 'Architect'] },
  { id: '24', primary: 'Lucille Hale', secondary: ['Leads', 'Engineer'] },
  { id: '25', primary: 'Angelina Pitt', secondary: ['Leads', 'Engineer'] },
  { id: '26', primary: 'Tanya Robinson', secondary: ['Leads', 'Architect'] },
  { id: '27', primary: 'Laura Horowitz', secondary: ['Leads', 'Product Owner'] },
  {
    id: 't',
    label: 'Toms',
    items: [
      { id: '28', primary: 'Tom Jones' },
      { id: '29', primary: 'Tom Hardy' },
      { id: '30', primary: 'Tom Hanks' },
      { id: '31', primary: 'Tom Sawyer' }
    ]
  }
];

export const treeItem = {
  id: '01',
  primary: 'Group',
  secondary: ['Leads', 'Engineer'],
  items: [
    { id: '01-1', primary: 'Paul McDonald', secondary: ['Leads', 'Engineer'] },
    { id: '01-2', primary: 'Frank Walker', secondary: ['Leads', 'Engineer'] },
    { id: '01-3', primary: 'Edward Green', secondary: ['Leads', 'Engineer'] }
  ]
};

export const tree = [treeItem, ...list];

export const createNewButton = (
  <Button variant='link' onClick={() => {}}>
    <Icon name='plus' /> Create new
  </Button>
);
